module.exports = __webpack_public_path__ + "img/standing behind you.5cecba9c.png";